import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MdsIcon, MdsIconsModule } from '@mds/icons';
import { GridOverrides } from '@mds/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent, getFieldType } from '@mds/ui';
import { map } from 'rxjs/operators';
import { ToastrService } from '@services/toaster.service';
import { MakersiteService } from '@services/makersite.service';
import { InformationRequestService } from '@pages/information-requests/information-request.service';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-edit-scip-category',
  templateUrl: './edit-scip-category.component.html',
  styleUrls: ['./edit-scip-category.component.scss'],
  imports: [
    CommonModule,
    MdsIconsModule,
    FormlyModule,
    MatInputModule,
    ButtonComponent,
    MatTooltipModule,
    MatIconModule,
    MatDialogModule,
    ReactiveFormsModule
  ],
  standalone: true,
  providers: [InformationRequestService]
})
export class EditScipCategoryComponent implements OnInit {
  mdsIcon = MdsIcon;
  articleForm: FormGroup;
  formField: any = [];
  model: { scip_article_category?: string } = {};
  selectedProductsOverrides: GridOverrides;
  productEdgeResponse = [];
  submitDataEmitter = new EventEmitter();

  constructor(
    private dialogRef: MatDialogRef<EditScipCategoryComponent>,
    private toastrService: ToastrService,
    private makersiteService: MakersiteService,
    private informationRequestService: InformationRequestService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.formField = [
      {
        key: 'scip_article_category',
        defaultValue: '',
        type: getFieldType('scip_article_category', 'autocomplete', 'autocomplete_v1'),
        templateOptions: {
          label: 'Category',
          info: '',
          placeholder: 'Select category',
          disabled: false,
          suffix: '',
          prefix: '',
          type: 'link',
          required: true,
          fetchOptions: (search: string, page: number) => this.getCategoryOptions(search, page),
          vertical: true
        }
      }
    ];
    this.articleForm = new FormGroup({
      scip_article_category: new FormControl(null, Validators.required)
    });
    this.formField[0].defaultValue = this.data?.out_scip_article_category;
    this.model.scip_article_category = this.data?.out_scip_article_category ?? '';
  }

  onSave() {
    if (
      this.articleForm.invalid ||
      this.articleForm.value.scip_article_category === this.data.out_scip_article_category
    ) {
      return;
    }
    this.updateCategory();
  }

  updateCategory() {
    const payload = {
      [this.data.rid]: {
        out_scip_article_category: [{ in: this.articleForm.value.scip_article_category }]
      }
    };
    this.informationRequestService.saveRequest(this.data.requestRid, payload).subscribe(() => {
      this.submitDataEmitter.emit(true);
      this.toastrService.show('Category updated Successfully', 2000);
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  getCategoryOptions(search: string, page: number) {
    const type = 'articles';
    let url = `scip/${type}/categories/search/${search}`;
    if (page) {
      url += `${url.includes('?') ? '&' : '?'}page=${page}`;
    }
    return this.makersiteService.getBaseData(url).pipe(map((res: any) => res));
  }
}
